import * as React from 'react';
import { MessageData } from 'src/components/TopUpProcedure/RealexForm/helper';

interface PropsType {
    className?: string,
    src?: string,
    target?: string,
    name?: string,
    title?: string,
    onMessage?: (data: MessageData) => void,
    allowFullScreen?: true,
    onLoad?: () => void,
}

export class Iframe extends React.Component<PropsType> {
    private ref: HTMLIFrameElement | null = null;

    private onMessage = (event: MessageEvent): void => {
        console.log('EVENT', event);

        if (this.ref !== null && this.props.onMessage !== undefined) {

            //realex topup iframe for new and saved
            const parsedData = JSON.parse(event.data);
            if (parsedData.type === 'success' || parsedData.type === 'error') {
                this.props.onMessage(JSON.parse(event.data));
            }
        }
    }

    public componentDidMount(): void {
        window.addEventListener('message', this.onMessage);
    }

    public componentWillUnmount(): void {
        window.removeEventListener('message', this.onMessage);
    }

    private setRef = (ref: HTMLIFrameElement | null): void => {
        this.ref = ref;
    }

    public render(): JSX.Element {
        const { className, src, title, name, allowFullScreen, onLoad } = this.props;

        return (
            <iframe
                className={className}
                src={src}
                ref={this.setRef}
                title={title}
                name={name}
                allowFullScreen={allowFullScreen}
                onLoad={onLoad}
            />
        );
    }
}
